import { DateRange } from 'owa-datetime-utils';
import * as publicActions from './publicActions';
import * as internalActions from './internalActions';
import { ClientItemId } from 'owa-client-ids';

export function getScenarioActions(scenarioId: string) {
    if (!scenarioId) {
        throw new Error('The scenarioId should be provided');
    }

    return {
        updateSelectedCalendarEvent: (selectedCalendarEventId: string) =>
            internalActions.updateSelectedCalendarEvent(selectedCalendarEventId, scenarioId),
        initializePane: () => internalActions.initializePane(scenarioId),
        updateLoadingInitialData: (isLoading: boolean) =>
            internalActions.updateLoadingInitialData(isLoading, scenarioId),
        setUpNextCalendarEventInStore: (upNext: { id: string | null; index: number | null }) =>
            internalActions.setUpNextCalendarEventInStore(upNext, scenarioId),
        refreshUpNextCalendarEventAction: (folderIds: string[]) =>
            internalActions.refreshUpNextCalendarEventAction(folderIds, scenarioId),
        cancelRefreshUpNextPoll: () => internalActions.cancelRefreshUpNextPoll(scenarioId),
        initializeRefreshUpNextPoll: (folderIds: string[], dateRange: DateRange) =>
            internalActions.initializeRefreshUpNextPoll(folderIds, dateRange, scenarioId),
        loadEventsForDateRange: (folderIds: string[], dateRange: DateRange) =>
            internalActions.loadEventsForDateRange(folderIds, dateRange, scenarioId),
        doubleClickAgendaEvent: (id: ClientItemId, target: any) =>
            publicActions.doubleClickAgendaEvent(id, target, scenarioId),
        clickAgendaEvent: (id: ClientItemId, target: any) =>
            publicActions.clickAgendaEvent(id, target, scenarioId),
        rightClickAgendaEvent: (id: ClientItemId, parentFolderId: string, evt: any) =>
            publicActions.rightClickAgendaEvent(id, parentFolderId, evt, scenarioId),
    };
}
